import {usesCustomerDashboard} from './dashboard_role';
import {railsToJsTimezoneMap} from './timezone_utils';

export function customerRescheduleTarget(user, project, search, now = new Date()) {
  if (!usesCustomerDashboard(user) || !project) return null;
  const canManage = user.id === project.client_id ||
    (user.roles.broker && user.firm?.name && user.firm.name === project.client?.firm?.name);
  if (!canManage) return null;
  const id = Number(new URLSearchParams(search || '').get('reschedule_package_id'));
  if (!Number.isInteger(id) || id <= 0) return null;
  const packs = Object.values(project.packages || {});
  const selected = packs.find(pack => pack.id === id);
  if (!selected?.appointment_time) return null;
  const time = new Date(selected.appointment_time);
  const zone = project.address?.timezone || project.client?.timezone || 'America/New_York';
  const timezone = railsToJsTimezoneMap[zone] || zone;
  if (!(time > now) || time.toLocaleDateString('en-CA', {timeZone: timezone}) === now.toLocaleDateString('en-CA', {timeZone: timezone})) return null;
  return {
    selected,
    packages: packs.filter(pack => pack.contractor_id === selected.contractor_id && pack.appointment_time === selected.appointment_time),
    photographer: project.photographers?.find(person => person.id === selected.contractor_id)
  };
}
